import script from "./OrgEngagementDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgEngagementDetails.vue?vue&type=script&setup=true&lang=js"

import "./OrgEngagementDetails.vue?vue&type=style&index=0&id=571fd3d9&scoped=true&lang=css"

import exportComponent from "/Users/jwmoreland/Documents/_Develop/HIRC Website/wp-content/themes/hirc-custom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-571fd3d9"]])

export default __exports__